import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { fetchFeaturedListings } from '../../ducks/featuredListings.duck';
import { NON_SALE_LISTING_TYPES, getSaleListingTypeIds } from '../../util/collections';

export const ASSET_NAME = 'landing-page';

// Nextmine: "Recently listed" på forsiden viser de nyeste rigtige varer i
// stedet for eksempel-tekst. Genbruger skabelonens eksisterende
// featuredListings-motor (samme som PageBuilder's indbyggede Listings-sektion).
export const RECENT_LISTINGS_SECTION_ID = 'nextmine-recently-listed';

// Forsiden viser ikke bare de 10 nyeste hver eneste dag. De nyeste står altid
// øverst, og de sidste pladser roterer, så ældre varer også kommer forbi
// forsiden. Udvalget er det samme i en time ad gangen - se
// src/util/listingRotation.js for hvorfor det skal være forudsigeligt.
export const RECENT_LISTINGS_ROTATION = {
  count: 10, // pladser på forsiden
  pinNewest: 4, // de nyeste vises altid
  poolSize: 48, // så mange varer roterer de sidste pladser imellem
  intervalMs: 60 * 60 * 1000, // nyt udvalg hver time
};

// "Recently listed" må kun vise VARER. Efterlysninger og samlingsstykker er
// egne listing-typer på inquiry-processen - de har ingen pris og er ikke til
// salg, så de hører ikke hjemme i forsidens varestrøm. Derfor begrænser vi
// forespørgslen positivt til salgs-typerne (samme princip som /s-søgningen).
export const recentListingsSections = config => {
  const saleTypeIds = getSaleListingTypeIds(config?.listing?.listingTypes);
  const hasNonSaleType = (config?.listing?.listingTypes || []).some(lt =>
    NON_SALE_LISTING_TYPES.includes(lt.listingType)
  );
  const restrictToSaleTypes = hasNonSaleType && saleTypeIds.length > 0;

  return [
    {
      sectionId: RECENT_LISTINGS_SECTION_ID,
      sectionType: 'listings',
      listingRotation: RECENT_LISTINGS_ROTATION,
      ...(restrictToSaleTypes
        ? {
            listingSelection: 'queryString',
            listingSearchQuery: { pub_listingType: saleTypeIds },
          }
        : { listingSelection: 'newest' }),
    },
  ];
};

export const loadData = (params, search, config) => dispatch => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
  const listingImageConfig = config?.layout?.listingImage || {};

  return Promise.all([
    dispatch(fetchPageAssets(pageAsset, true)),
    dispatch(
      fetchFeaturedListings({
        sectionId: RECENT_LISTINGS_SECTION_ID,
        parentPage: ASSET_NAME,
        listingImageConfig,
        allSections: recentListingsSections(config),
      })
    ),
  ]);
};
